import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadNotesUpdateAtom = createMutationAtomFactory(
  'trade.purchaseLoadNotesUpdate',
  (params: { id: string; internalNotes: string; externalNotes: string }) => ({
    tradePurchaseLoadUpdate: {
      __args: {
        id: params.id,
        input: {
          internalNotes: params.internalNotes,
          externalNotes: params.externalNotes,
        },
      },
      id: true,
    },
  }),
  { showLoadingOverlay: false },
);
